import type { SessionDocDetail } from '../types';

export interface StreamedSessionDoc {
  document_id?: string;
  tool_use_id?: string | null;
  tool_name?: string;
  doc_type?: string;
  title?: string | null;
  summary?: string | null;
  data?: any;
  metadata?: Record<string, any>;
  timestamp?: string;
}

export function sessionDocToStreamEvent(
  doc: SessionDocDetail | StreamedSessionDoc,
): Record<string, any> {
  const timestamp = 'created_at' in doc
    ? doc.created_at
    : doc.timestamp;

  return {
    type: 'session_doc',
    label: doc.title || doc.summary,
    documentId: doc.document_id,
    docType: doc.doc_type,
    toolName: doc.tool_name,
    data: doc.data,
    metadata: doc.metadata || {},
    timestamp: timestamp || new Date().toISOString(),
  };
}
